import React, { useMemo } from "react";
import { noop } from "@common/helpers/function";
import { FilterActionsFooter } from "@design-system/Filter/FilterActionsFooter/FilterActionsFooter";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

interface SearchableItem {
    id: string;
    name: string;
}

interface Props {
    items: SearchableItem[];
    selectedIds: string[] | undefined;
    onChange: (selectedIds: string[] | undefined) => void;
    name: string;
}

export const SearchableIdListFilter: React.FC<Props> = ({
    items,
    selectedIds,
    onChange,
    name,
}) => {
    const options = useMemo<FilterMultiselectOption[]>(
        () =>
            items.map((item) => ({
                value: item.id,
                label: item.name,
                searchableLabel: item.name,
            })),
        [items],
    );

    const value = selectedIds ?? [];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                options={options}
                value={value}
                onChange={(val) => {
                    const selected = val.map(String);
                    onChange(selected.length ? selected : undefined);
                }}
                name={name}
                onBlur={noop}
            />
            {!!selectedIds?.length && (
                <FilterActionsFooter
                    deselectFunction={() => onChange(undefined)}
                    selectedCount={selectedIds.length}
                />
            )}
        </div>
    );
};
